import {
  PartialResellerCertificate,
  ResellerCertificate,
} from 'domains/resellerCertificateDomain';
import api from 'utils/api';

const resellerCertificateService = {
  getPaged: async (
    {
      size,
      page,
    }: {
      size: number;
      page: number;
    },
    headers?: {}
  ) => {
    return api.get<ResellerCertificate[]>(
      `/api/orgs/reseller-certificate?size=${size}&page=${page - 1}`
    );
  },

  updateResellerCertificate: async (payload: PartialResellerCertificate) => {
    return api.put(`/api/orgs/reseller-certificate`, payload);
  },
};

export default resellerCertificateService;
